export default __webpack_public_path__ + "static/media/review-contest-fr.933e1829.png";